import * as angular from 'angular';

const IbPlusMyBonusConstants = {
    DATA:[
        {
            campaign:{
                id:'694',
                commercialCode:'TR-WA-EUR'
            },
            id:'2989113',
            commercialCode:'TRCNT200EUR-IDT6',
            type:'GIFT_CARD',
            amount:200,
            remaining:200,
            currency:{
                code:'EUR',
                description:'Euro',
                symbol:'€',
                alignment:'R',
                groupingSeparator:'.',
                decimalSeparator:',',
                recommendedDisplay:'symbol',
                decimals:2
            },
            percentage:false,
            maxUsages:0,
            redemptionForBooking:true,
            bookingReferences:[
                {
                    reference:'LL6I3A',
                    date:'2021-05-13 09:43:36',
                    amount:50.85
                },
                {
                    reference:'KS5Y2',
                    date:'2021-05-13 14:30:17',
                    amount:131.95
                },
                {
                    reference:'LRB5SR',
                    date:'2021-05-14 11:49:54',
                    amount:67.2
                }
            ],
            journey:{
                allowedOperatorsNotSelected:false,
                itineraryTypes:['3', '1', '2'],
                departure:{},
                arrival:{},
                sundayRule:false
            },
            hashedEmail:'513e6874856ed5eb4d9adcb39171e1c1270bdc79cf5428d8f46b8940a0e4533a',
            status:'CREATED'
        },
        {
            campaign:{
                id:'666',
                commercialCode:'TRLAU_50EURO'
            },
            id:'3047620',
            commercialCode:'TRCNT200EUR-IDT7',
            type:'GIFT_CARD',
            amount:200,
            remaining:200,
            currency:{
                code:'EUR',
                description:'Euro',
                symbol:'€',
                alignment:'R',
                groupingSeparator:'.',
                decimalSeparator:',',
                recommendedDisplay:'symbol',
                decimals:2
            },
            percentage:false,
            maxUsages:2,
            expiryDate:{
                from:'2021-09-14 00:00:00',
                to:'2022-09-14 23:59:59'
            },
            redemptionForBooking:true,
            bookingReferences:[],
            journey:{
                companies:[
                    {
                        code:'IB',
                        description:'Iberia'
                    },
                    {
                        code:'YW',
                        description:'Iberia Regional Air Nostrum'
                    },
                    {
                        code:'I2',
                        description:'Iberia Express'
                    }
                ],
                allowedOperatorsNotSelected:false,
                departure:{
                    allowed:{
                        from:'2021-04-14 00:00:00',
                        to:'2022-04-30 23:59:59'
                    }
                },
                arrival:{
                    allowed:{
                        from:'2021-09-14 00:00:00',
                        to:'2022-09-14 23:59:59'
                    }
                },
                sundayRule:false
            },
            hashedEmail:'10a85e44c69cd0f7508fc381321eff1823ba8027d99912d68402a041130ae640',
            status:'CREATED'
        },
        {
            campaign:{
                id:'666',
                commercialCode:'TRLAU_50EURO'
            },
            id:'3047620',
            commercialCode:'TRCNT200EUR-IDT8',
            type:'GIFT_CARD',
            amount:200,
            remaining:200,
            currency:{
                code:'EUR',
                description:'Euro',
                symbol:'€',
                alignment:'R',
                groupingSeparator:'.',
                decimalSeparator:',',
                recommendedDisplay:'symbol',
                decimals:2
            },
            percentage:false,
            maxUsages:2,
            expiryDate:{
                from:'2021-09-14 00:00:00',
                to:'2022-09-14 23:59:59'
            },
            redemptionForBooking:true,
            bookingReferences:[],
            journey:{
                companies:[
                    {
                        code:'IB',
                        description:'Iberia'
                    },
                    {
                        code:'YW',
                        description:'Iberia Regional Air Nostrum'
                    },
                    {
                        code:'I2',
                        description:'Iberia Express'
                    }
                ],
                allowedOperatorsNotSelected:false,
                departure:{
                    allowed:{
                        from:'2021-04-14 00:00:00',
                        to:'2022-04-30 23:59:59'
                    }
                },
                arrival:{
                    allowed:{
                        from:'2021-09-14 00:00:00',
                        to:'2022-09-14 23:59:59'
                    }
                },
                sundayRule:false
            },
            hashedEmail:'10a85e44c69cd0f7508fc381321eff1823ba8027d99912d68402a041130ae640',
            status:'CREATED'
        },
        {
            campaign:{
                id:'666',
                commercialCode:'FB2-TRRtSEmfko'
            },
            id:'3047620',
            commercialCode:'TRCNT200EUR-IDT9',
            type:'GIFT_CARD',
            amount:200,
            remaining:200,
            currency:{
                code:'EUR',
                description:'Euro',
                symbol:'€',
                alignment:'R',
                groupingSeparator:'.',
                decimalSeparator:',',
                recommendedDisplay:'symbol',
                decimals:2
            },
            percentage:false,
            maxUsages:2,
            expiryDate:{
                from:'2021-09-14 00:00:00',
                to:'2022-09-14 23:59:59'
            },
            redemptionForBooking:true,
            bookingReferences:[],
            journey:{
                companies:[
                    {
                        code:'IB',
                        description:'Iberia'
                    },
                    {
                        code:'YW',
                        description:'Iberia Regional Air Nostrum'
                    },
                    {
                        code:'I2',
                        description:'Iberia Express'
                    }
                ],
                allowedOperatorsNotSelected:false,
                departure:{
                    allowed:{
                        from:'2021-04-14 00:00:00',
                        to:'2022-04-30 23:59:59'
                    }
                },
                arrival:{
                    allowed:{
                        from:'2021-09-14 00:00:00',
                        to:'2022-09-14 23:59:59'
                    }
                },
                sundayRule:false
            },
            hashedEmail:'10a85e44c69cd0f7508fc381321eff1823ba8027d99912d68402a041130ae640',
            status:'CREATED'
        },
        {
            campaign:{
                id:'666',
                commercialCode:'TRLAU_50EURO'
            },
            id:'3047620',
            commercialCode:'TRCNT200EUR-IDT10',
            type:'GIFT_CARD',
            amount:300,
            remaining:300,
            currency:{
                code:'EUR',
                description:'Euro',
                symbol:'€',
                alignment:'R',
                groupingSeparator:'.',
                decimalSeparator:',',
                recommendedDisplay:'symbol',
                decimals:2
            },
            percentage:false,
            maxUsages:2,
            expiryDate:{
                from:'2021-09-14 00:00:00',
                to:'2022-09-14 23:59:59'
            },
            redemptionForBooking:true,
            bookingReferences:[],
            journey:{
                companies:[
                    {
                        code:'IB',
                        description:'Iberia'
                    },
                    {
                        code:'YW',
                        description:'Iberia Regional Air Nostrum'
                    },
                    {
                        code:'I2',
                        description:'Iberia Express'
                    }
                ],
                allowedOperatorsNotSelected:false,
                departure:{
                    allowed:{
                        from:'2021-04-14 00:00:00',
                        to:'2022-04-30 23:59:59'
                    }
                },
                arrival:{
                    allowed:{
                        from:'2021-09-14 00:00:00',
                        to:'2022-09-14 23:59:59'
                    }
                },
                sundayRule:false
            },
            hashedEmail:'10a85e44c69cd0f7508fc381321eff1823ba8027d99912d68402a041130ae640',
            status:'CREATED'
        }
    ],
    STATUS:{
        FRAUD: 'FRAUD',
        REFUND: 'REFUND',
        CHANGE: 'CHANGE',
        DUPLICATE: 'DUPLICATE',
        MERGE: 'MERGE',
        EMD: 'EMD',
        REVENUE_ACCOUNTING: 'REVENUE_ACCOUNTING',
        CREATED: 'CREATED'
    },
    MMB:'MANAGE_MY_BOOKING_LINK_'

};
try{
    const mod = angular.module('ib-plus-my-bonus-module');

    mod.constant(
        'IbPlusMyBonusConstants', IbPlusMyBonusConstants
    );
}catch(error) {
    const mod = angular.module('ib-plus-my-bonus-module', []);
    mod.constant(
        'IbPlusMyBonusConstants', IbPlusMyBonusConstants
    );
}
export type IbPlusMyBonusConstantsType = typeof IbPlusMyBonusConstants;
export { IbPlusMyBonusConstants };
